// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-info-ls li[data-v-abc22678]{list-style-type:none;margin:12px 0;border-bottom:1px dashed #ccc}.item-info-ls li .item-info[data-v-abc22678]{margin-top:5px;margin-bottom:10px;font-size:.83333em}.item-info-ls li a.el-link[data-v-abc22678]:focus{border:.1em solid #fff;-webkit-box-shadow:0 0 0 .1em #000 inset;box-shadow:inset 0 0 0 .1em #000;border-radius:.25em;padding:.1em .2em}", ""]);
// Exports
module.exports = exports;
